// import React, { useEffect, useState } from "react";
// import Navbar from "../components/navbar";
// import { FaRegTrashAlt } from "react-icons/fa";

// const Mailbox = () => {
//   const [messages, setMessages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState("");

//   useEffect(() => {
//     const fetchMessages = async () => {
//       try {
//         const res = await fetch(
//           "http://localhost:8000/messages?email=ali@gmail.com"
//         );
//         const data = await res.json();
//         console.log("API response:", data);

//         if (Array.isArray(data)) {
//           setMessages(data);
//         } else {
//           console.warn("Unexpected API response:", data);
//           setMessages([]);
//         }
//       } catch (err) {
//         console.error("Error fetching messages:", err);
//         setMessages([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMessages();
//   }, []);

//   // Delete message
//   const handleDelete = async (id) => {
//     try {
//       await fetch(`http://localhost:8000/messages/${id}`, {
//         method: "DELETE",
//       });
//       setMessages((prev) => prev.filter((msg) => msg.id !== id));
//     } catch (err) {
//       console.error("Error deleting message:", err);
//     }
//   };

//   // Filter messages based on search input
//   const filteredMessages = messages.filter(
//     (msg) =>
//       msg.sender_email?.toLowerCase().includes(search.toLowerCase()) ||
//       msg.body.toLowerCase().includes(search.toLowerCase())
//   );

//   return (
//     <div className="max-w-3xl mx-auto p-6 pt-24">
//       <Navbar />
//       <h1 className="text-5xl font-bold text-center mb-6 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-cyan-500 pt-8">
//           Mailbox
//         </h1>

//       {/* Search Bar */}
//       <div className="mb-6">
//         <input
//           type="text"
//           placeholder="Search messages..."
//           value={search}
//           onChange={(e) => setSearch(e.target.value)}
//           className="w-full px-4 py-2 border rounded-md shadow-sm focus:outline-none focus:ring focus:ring-blue-300"
//         />
//       </div>

//       {loading ? (
//         <p>Loading...</p>
//       ) : filteredMessages.length === 0 ? (
//         <p>No messages found.</p>
//       ) : (
//         <ul className="space-y-4">
//           {filteredMessages.map((msg) => (
//             <li
//               key={msg.id}
//               className="p-5 rounded-lg border border-gray-200 shadow bg-white hover:shadow-md transition"
//             >
//               <div className="flex justify-between items-start">
//                 <div>
//                   <p className="text-sm text-gray-500">
//                     From: {msg.sender_email || "Unknown"}
//                   </p>
//                   <p className="text-gray-800 mt-1">{msg.body}</p>
//                   <p className="text-xs text-gray-400 mt-2">
//                     {msg.time_received
//                       ? new Date(msg.time_received).toLocaleString()
//                       : "Unknown date"}
//                   </p>
//                 </div>
//                 {/* Delete button */}
//                 <button
//                   onClick={() => handleDelete(msg.id)}
//                   className="ml-4 text-red-600 hover:text-red-800 font-semibold"
//                 >
                  
//                  <FaRegTrashAlt />
//                 </button>
//               </div>
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// };

// export default Mailbox;





















import React, { useEffect, useState } from "react";
import Navbar from "../components/navbar";
import { FaRegTrashAlt } from "react-icons/fa";

const Mailbox = () => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const res = await fetch(
          "http://localhost:8000/messages?email=ali@gmail.com"
        );
        const data = await res.json();
        console.log("API response:", data);

        if (Array.isArray(data)) {
          setMessages(data);
        } else {
          console.warn("Unexpected API response:", data);
          setMessages([]);
        }
      } catch (err) {
        console.error("Error fetching messages:", err);
        setMessages([]);
      } finally {
        setLoading(false);
      }
    };

    fetchMessages();
  }, []);

  // Delete message
  const handleDelete = async (id) => {
    try {
      await fetch(`http://localhost:8000/messages/${id}`, {
        method: "DELETE",
      });
      setMessages((prev) => prev.filter((msg) => msg.id !== id));
    } catch (err) {
      console.error("Error deleting message:", err);
    }
  };

  // Filter messages based on search input
  const filteredMessages = messages.filter(
    (msg) =>
      msg.sender_email?.toLowerCase().includes(search.toLowerCase()) ||
      msg.body.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-blue-50">
      <Navbar />
      <div className="pt-28 flex flex-col items-center px-4">
        <h1 className="text-5xl font-bold text-center mb-10 bg-clip-text text-transparent bg-gradient-to-r from-blue-600 to-cyan-500">
          Mailbox
        </h1>

        {/* Search Bar */}
        <div className="w-full max-w-md mb-8">
          <input
            type="text"
            placeholder="Search messages..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full px-4 py-2 border rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>

        {/* Messages */}
        <div className="w-full max-w-2xl">
          {loading ? (
            <p className="text-center text-gray-600">Loading...</p>
          ) : filteredMessages.length === 0 ? (
            <p className="text-center text-gray-600">No messages found.</p>
          ) : (
            <ul className="space-y-4">
              {filteredMessages.map((msg) => (
                <li
                  key={msg.id}
                  className="p-5 rounded-lg border border-gray-200 shadow bg-white hover:shadow-md transition"
                >
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="text-sm text-gray-500">
                        From: {msg.sender_email || "Unknown"}
                      </p>
                      <p className="text-gray-800 mt-1">{msg.body}</p>
                      <p className="text-xs text-gray-400 mt-2">
                        {msg.time_received
                          ? new Date(msg.time_received).toLocaleString()
                          : "Unknown date"}
                      </p>
                    </div>
                    {/* Delete button */}
                    <button
                      onClick={() => handleDelete(msg.id)}
                      className="ml-4 text-red-600 hover:text-red-800"
                    >
                      <FaRegTrashAlt />
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
};

export default Mailbox;
